const shader = `
#define FLOAT_OFFSET 0.25

vec4 makeColor(int index) {
    vec4 color = vec4(
        float(index >> 24 & 255),
        float(index >> 16 & 255),
        float(index >> 8 & 255),
        float(index & 255)
    );

    return (color + FLOAT_OFFSET) / 255.0;
}
`;

export default shader;